import { queryOptions, useQuery } from '@tanstack/react-query';

import { QUERY_STALE_TIME } from '@/config/queryDefaults';
import { parseBackendData } from '@/shared/lib/format/parseBackendData';

import { catalogApi } from './catalog.api';

export const catalogOptions = {
  spot: () =>
    queryOptions({
      queryKey: ['spotCatalog'] as const,
      queryFn: catalogApi.getSpotCatalog,
      select: parseBackendData,
      refetchOnWindowFocus: false,
      staleTime: QUERY_STALE_TIME.standard
    }),
  forward: () =>
    queryOptions({
      queryKey: ['forwardCatalog'] as const,
      queryFn: catalogApi.getForwardCatalog,
      select: parseBackendData,
      refetchOnWindowFocus: false,
      staleTime: QUERY_STALE_TIME.standard
    })
};

export const useSpotCatalog = () => useQuery(catalogOptions.spot());
export const useForwardCatalog = () => useQuery(catalogOptions.forward());
